// it意大利
export default {
    CustomSelect: {
        '请选择': 'Seleziona',
    },
    TopNav: {
        '创作者': 'Creatore',
        '游客': 'Visitatore',
        '请登录后体验完整功能': 'Accedi per tutte le funzionalità',
        '登录': 'Accedi',
        '免费试用': 'Prova gratuita',
        '退出登录': 'Esci',
        '个人中心': 'Il mio account',
        '我的视频': 'I miei video',
        '额度管理': 'Gestione crediti',
        '首页': 'Home',
        'AI创作': 'Creazione AI',
        '多参考': 'Multi-riferimento',
        '文本视频': 'Testo in video',
        '图片视频': 'Immagine in video',
        '文生图': 'Testo in immagine',
        '图生图': 'Immagine in immagine',
        '会员中心': 'Area membri',
        '概览': 'Panoramica',
        '我的创作': 'Le mie creazioni',
        '账单管理': 'Gestione fatture',
        '生成任务': 'Attività di generazione',
        '价格': 'Prezzi',
        '新闻资讯': 'Notizie',
        '确定要退出登录吗？': 'Vuoi uscire?',
        '提示': 'Suggerimento',
        '确定': 'OK',
        '取消': 'Annulla',
        '退出成功': 'Uscito con successo',
        '视频展示': 'video dimostrativo'
    },
    AiLayout: {
        'AI创作中心': 'Centro creativo AI',
        '视频生成': 'Genera video',
        '图片生成': 'Genera immagine',
        '我的作品': 'Le mie opere',
        '我的创作': 'Le mie creazioni',
        '今日剩余额度': 'Credito residuo oggi',
        '多参考': 'Multi-riferimento',
        '文本视频': 'Testo in video',
        '图片视频': 'Immagine in video',
        '文生图': 'Testo in immagine',
        '图生图': 'Immagine in immagine',
    },
    HomeLayout: {
        '下一代AI视频生成平台': 'Piattaforma di prossima generazione per la generazione video AI, trasforma le idee in realtà istantaneamente',
        '产品': 'Prodotti',
        'AI视频': 'Video AI',
        '价格方案': 'Piani tariffari',
        '新闻资讯': 'Notizie',
        '支持': 'Supporto',
        '帮助中心': 'Centro assistenza',
        'API文档': 'Documentazione API',
        '常见问题': 'FAQ',
        '法律': 'Legale',
        '服务条款': 'Termini di servizio',
        '隐私政策': 'Informativa sulla privacy',
        '使用协议': 'Accordo di utilizzo',
        '版权所有': 'Tutti i diritti riservati',
        '客服邮箱': 'Email assistenza',
        '复制邮箱': 'Copia email',
        '开发中': 'In sviluppo, resta sintonizzato!',
        '链接已复制到剪贴板': 'Link copiato negli appunti',
    },
    MyLayout: {
        '创作者': 'Creatore',
        '退出登录': 'Esci',
        '概览': 'Panoramica',
        '我的创作': 'Le mie creazioni',
        '会员中心': 'Area membri',
        '额度管理': 'Gestione crediti',
        '账单管理': 'Gestione fatture',
        '生成任务': 'Attività di generazione',
        '确定要退出登录吗？': 'Vuoi uscire?',
        '提示': 'Suggerimento',
        '确定': 'OK',
        '取消': 'Annulla',
        '退出成功': 'Uscito con successo'
    },
    Image: {
        "文本生成图片": "Testo in immagine",
        "图片生成图片": "Immagine in immagine",
        "用文字描述": "Descrivi a parole l'immagine che desideri",
        "上传图片素材": "Carica materiale immagine, supporta generazione multi-immagine",
        "图片描述": "Descrizione immagine",
        "描述您想要的图片": "Descrivi in dettaglio il contenuto dell'immagine che desideri generare, supporta italiano o inglese...",
        "提示描述越详细效果越好": "Suggerimento: Più dettagliata è la descrizione, migliore è il risultato della generazione",
        "图片素材": "Materiale immagine",
        "预览图片": "Anteprima",
        "上传图片": "Carica immagine",
        "支持格式JPGPNG": "Supporta formati JPG, PNG",
        "最多": "Massimo",
        "张图片": "immagine(i)",
        "超过大小限制": "Supera il limite di 10MB",
        "不是图片文件": "File immagine non valido",
        "最多上传": "Caricamento massimo",
        "请先上传图片": "Si prega di caricare prima il materiale immagine",
        "请选择要生成的图片": "Seleziona l'immagine da generare",
        "生成结果": "Risultato generazione",
        "重新生成成功": "Rigenerazione riuscita",
        "模型": "Modello AI",
        "请选择模型": "Seleziona il modello di generazione",
        "分辨率": "Risoluzione di output",
        "请选择分辨率": "Seleziona la risoluzione",
        "图片比例": "Proporzioni immagine",
        "补充描述": "Descrizione aggiuntiva (opzionale)",
        "补充描述提示": "Opzionale, descrivi eventuali effetti o stili aggiuntivi che desideri per l'immagine",
        "开始绘制": "Inizia a disegnare",
        "开始生成": "Inizia generazione",
        "生成中": "Generazione in corso, attendere...",
        "生成成功": "Generazione riuscita",
        "图片生成成功": "Immagine generata con successo!",
        "作品已保存到我的作品": "L'opera è stata salvata in 'Le mie opere'",
        "继续创作": "Continua a creare",
        "查看作品": "Vedi opera",
        "请输入图片描述": "Inserisci la descrizione dell'immagine"
    },
    MyCreation: {
        '我的创作': 'Le mie creazioni',
        '查看和管理您的所有作品': 'Visualizza e gestisci tutte le tue opere',
        '预览': 'Anteprima',
        '下载': 'Scarica',
        '编辑': 'Modifica',
        '分享': 'Condividi',
        '删除': 'Elimina',
        '暂无作品': 'Nessuna opera',
        '去创作': 'Crea',
        '确定删除': 'Conferma eliminazione',
        '确定要删除作品': 'Vuoi eliminare l\'opera',
        '吗？': '?',
        '此操作不可恢复': 'Questa azione è irreversibile, presta attenzione!',
        '取消': 'Annulla',
        '分享作品': 'Condividi opera',
        '复制链接': 'Copia link',
        '全部': 'Tutti',
        '视频': 'Video',
        '图片': 'Immagine',
        '正在下载:': 'Download in corso: ',
        '链接已复制到剪贴板': 'Link copiato negli appunti',
        '删除成功': 'Eliminazione riuscita'
    },
    Video: {
        "文本生成视频": "Testo in video",
        "图片生成视频": "Immagine in video",
        "智能视频生成": "Generazione video intelligente",
        "输入文字描述": "Inserisci descrizione testuale",
        "上传1-9张图片": "Carica 1-9 immagini",
        "上传图片视频音频": "Carica immagine/video/audio",
        "视频描述": "Descrizione video",
        "描述您想要的视频场景": "Descrivi la scena video desiderata",
        "提示": "Suggerimento",
        "图片素材": "Materiale immagine",
        "最多上传": "Caricamento massimo",
        "张": "immagine(i)",
        "预览": "Anteprima",
        "上传图片": "Carica immagine",
        "支持格式": "Formati JPG, PNG, max 10MB per file, massimo",
        "AI": "L'AI integra in modo intelligente e genererà transizioni fluide",
        "动态描述": "Descrizione movimento",
        "描述您希望图片如何动起来": "Descrivi come vuoi che l'immagine si muova",
        "个": "elemento/i",
        "上传视频": "Carica video",
        "上传音频": "Carica audio",
        "描述您希望视频呈现的效果": "Descrivi l'effetto desiderato per il video",
        "模型": "Modello",
        "请选择模型": "Seleziona il modello",
        "分辨率": "Risoluzione",
        "请选择分辨率": "Seleziona la risoluzione",
        "宽高比": "Proporzioni",
        "视频时长": "Durata video",
        "生成音频": "Genera audio",
        "开启音效": "Attiva effetti sonori",
        "静音模式": "Modalità silenziosa",
        "音频提示": "Suggerimento: L'audio caricato verrà utilizzato come musica di sottofondo, se non viene caricato audio l'AI genererà automaticamente la musica",
        "开始生成": "Inizia generazione",
        "积分": "Crediti",
        "生成中": "Generazione in corso",
        "生成成功": "Generazione riuscita",
        "视频生成成功！": "Video generato con successo!",
        "作品已保存到": "L'opera è stata salvata in 'Le mie opere'",
        "继续创作": "Continua a creare",
        "查看作品": "Vedi opera",
        "视频预览": "Anteprima video",
        "关闭": "Chiudi",
        "下载视频": "Scarica video",
        "您的浏览器不支持视频播放": "Il tuo browser non supporta la riproduzione video",
        "生成进度": "Avanzamento generazione",
        "描述": "Descrizione",
        "时长": "Durata",
        "秒": "secondi",
        "视频素材": "Materiale video",
        "音频素材": "Materiale audio",
        "双图融合模式": "Modalità fusione doppia immagine",
        "开始下载视频": "Avvia download video",
        "请输入视频描述": "Inserisci la descrizione del video",
        "请至少上传一张图片": "Carica almeno un'immagine",
        "请至少上传一张图片或一个视频": "Carica almeno un'immagine o un video",
        "最多只能上传": "Caricamento massimo",
        "超过": "Supera",
        "限制": "limite",
        "不是图片文件": "File immagine non valido",
        "不是视频文件": "File video non valido",
        "不是音频文件": "File audio non valido"
    },
    Forgot: {
        "找回密码": "Recupera password",
        "请输入您的邮箱，我们将发送验证码": "Inserisci la tua email, ti invieremo un codice di verifica",
        "密码重置成功，请使用新密码登录": "Password reimpostata con successo, accedi con la nuova password",
        "密码重置成功": "Password reimpostata con successo",
        "您的密码已成功重置，请使用新密码登录": "La tua password è stata reimpostata con successo, accedi con la tua nuova password",
        "立即登录": "Accedi ora",
        "邮箱": "Email",
        "请输入注册邮箱": "Inserisci l'email registrata",
        "发送验证码": "Invia codice",
        "请输入验证码": "Inserisci il codice di verifica",
        "验证码": "Codice di verifica",
        "新密码": "Nuova password",
        "设置新密码": "Imposta nuova password",
        "确认新密码": "Conferma nuova password",
        "再次输入新密码": "Inserisci di nuovo la nuova password",
        "重置密码": "Reimposta password",
        "返回登录": "Torna al login",
        "验证中": "Verifica in corso",
        "重置中": "Reimpostazione in corso",
        "弱": "Debole",
        "中": "Media",
        "强": "Forte",
        "请输入邮箱地址": "Inserisci l'indirizzo email",
        "请输入正确的邮箱格式": "Inserisci un formato email valido",
        "验证码应为6位数字": "Il codice di verifica deve essere di 6 cifre",
        "请输入新密码": "Inserisci una nuova password",
        "密码至少需要6位": "La password deve essere di almeno 6 caratteri",
        "请再次输入新密码": "Inserisci di nuovo la nuova password",
        "两次输入的密码不一致": "Le password inserite non corrispondono",
        "验证码已发送": "Codice di verifica inviato"
    },
    Login: {
        "下一代AI视频生成平台": "Piattaforma di prossima generazione per la generazione video AI",
        "一键生成": "Generazione con un clic",
        "支持4K超高清输出": "Supporto uscita 4K Ultra HD",
        "多种风格模板任选": "Scegli tra vari modelli di stile",
        "商用授权无忧使用": "Licenza commerciale, usa senza preoccupazioni",
        "欢迎回来": "Bentornato",
        "登录您的账号继续创作": "Accedi per continuare a creare",
        "邮箱": "Email",
        "请输入邮箱地址": "Inserisci l'indirizzo email",
        "密码": "Password",
        "请输入您的密码": "Inserisci la tua password",
        "记住我": "Ricordami",
        "忘记密码？": "Password dimenticata?",
        "登录": "Accedi",
        "登录中": "Accesso in corso",
        "还没有账号？": "Non hai un account?",
        "立即注册": "Registrati ora",
        "请输入正确的邮箱格式": "Inserisci un formato email valido",
        "请输入密码": "Inserisci la password",
        "密码至少需要6位": "La password deve essere di almeno 6 caratteri",
        "密码不能超过20位": "La password non può superare i 20 caratteri",
        "登录成功": "Accesso riuscito"
    },
    Register: {
        "创建账号": "Crea account",
        "开始您的AI视频创作之旅": "Inizia il tuo viaggio nella creazione video AI",
        "姓名": "Nome",
        "请输入您的姓名": "Inserisci il tuo nome",
        "邮箱": "Email",
        "请输入邮箱地址": "Inserisci l'indirizzo email",
        "获取验证码": "Ottieni codice",
        "验证码": "Codice di verifica",
        "请输入验证码": "Inserisci il codice di verifica",
        "密码": "Password",
        "设置密码": "Imposta password",
        "确认密码": "Conferma password",
        "再次输入密码": "Inserisci di nuovo la password",
        "我已阅读并同意": "Ho letto e accetto",
        "服务条款": "Termini di servizio",
        "和": "e",
        "隐私政策": "Informativa sulla privacy",
        "注册中": "Registrazione in corso",
        "已有账号？": "Hai già un account?",
        "立即登录": "Accedi ora",
        "弱": "Debole",
        "中": "Media",
        "强": "Forte",
        "请输入姓名": "Inserisci il nome",
        "姓名至少需要2个字符": "Il nome deve essere di almeno 2 caratteri",
        "姓名不能超过20个字符": "Il nome non può superare i 20 caratteri",
        "请输入正确的邮箱格式": "Inserisci un formato email valido",
        "验证码应为6位数字": "Il codice di verifica deve essere di 6 cifre",
        "请输入密码": "Inserisci la password",
        "密码至少需要6位": "La password deve essere di almeno 6 caratteri",
        "密码不能超过20位": "La password non può superare i 20 caratteri",
        "请再次输入密码": "Conferma la password",
        "两次输入的密码不一致": "Le password inserite non corrispondono",
        "验证码已发送": "Codice di verifica inviato",
        "注册成功": "Registrazione riuscita"
    },
    Faq: {
        '常见问题': 'Domande frequenti',
        '您在使用过程中遇到的问题': 'I problemi che incontri durante l\'uso, trova le risposte qui',
        '搜索您的问题': 'Cerca la tua domanda...',
        '没有找到相关的问题': 'Nessuna domanda correlata trovata',
        '查看全部问题': 'Vedi tutte le domande',
        '没有找到您想要的答案？': 'Non hai trovato la risposta che cercavi?',
        '我们的客服团队随时为您提供帮助': 'Il nostro team di supporto è disponibile per aiutarti',
        '复制客服邮箱': 'Copia email assistenza',
        '链接已复制到剪贴板': 'Link copiato negli appunti'
    },
    Home: {
        '立即订阅': 'Si iscriva ora',
        'AI视频生成新时代': 'Nuova era della generazione video AI',
        '用文字创造': 'Crea con le parole',
        '无限视频': 'Video illimitati',
        '让每个人都能成为视频创作者': 'Permetti a tutti di diventare creatori di video. Basta inserire una descrizione testuale per ottenere video AI di alta qualità e unici.',
        '免费开始': 'Inizia gratis',
        '观看演示': 'Guarda la demo',
        'AI生成': 'Genera AI',
        'AI视频': 'Video AI',
        '三步轻松生成专业视频': 'Tre semplici passaggi per generare video professionali',
        '输入提示词': 'Inserisci prompt',
        '用文字描述您想要的视频内容': 'Descrivi a parole il contenuto video desiderato, più dettagliato è meglio è',
        '智能生成': 'Generazione intelligente',
        'AI模型自动理解并创作': 'Il modello AI comprende e crea automaticamente, il rendering è completato in pochi minuti',
        '下载作品': 'Scarica opera',
        '高清视频生成完成': 'Generazione video HD completata, pronto per il download e l\'uso immediato',
        'AI视频生成': 'Generazione video AI',
        '精彩视频': 'Inserisci una descrizione testuale, l\'AI genererà un video straordinario per te',
        '描述您想要的视频场景': 'Descrivi la scena video desiderata, ad esempio: Un gatto che gioca sotto un albero di ciliegio, la luce del sole che filtra attraverso i petali...',
        '生成中': 'Generazione in corso...',
        '生成视频': 'Genera video',
        'AI图片': 'Immagine AI',
        '精美图片': 'Inserisci una descrizione testuale, l\'AI genererà un\'immagine straordinaria per te',
        '描述您想要的图片场景': 'Descrivi la scena dell\'immagine desiderata, ad esempio: Orizzonte di una città futura, luci al neon lampeggianti, stile cyberpunk...',
        '生成图片': 'Genera immagine',
        '强大功能': 'Funzionalità potenti',
        '让视频创作变得简单有趣': 'Rendi la creazione video semplice e divertente',
        '案例展示': 'Esempi',
        '来看看用户使用': 'Guarda le opere straordinarie create dagli',
        '创作的精彩作品': 'utenti',
        '新闻资讯': 'Notizie',
        '了解': 'Scopri le',
        '的最新动态和产品更新': 'ultime novità e aggiornamenti dei prodotti',
        '查看更多': 'Vedi altro',
        '热门': 'Popolari',
        '最新': 'Recenti',
        '阅读更多': 'Leggi tutto',
        '选择适合您的方案': 'Scegli il piano adatto a te',
        '灵活的定价': 'Prezzi flessibili per diverse esigenze',
        '视频预览': 'Anteprima video',
        '生成成功': 'Generazione riuscita',
        '作品已保存到': 'L\'opera è stata salvata in "Le mie creazioni"',
        '继续创作': 'Continua a creare',
        '查看作品': 'Vedi opera',
        '请输入视频描述': 'Inserisci la descrizione del video',
        '视频生成成功！': 'Video generato con successo!',
        '请输入图片描述': 'Inserisci la descrizione dell\'immagine',
        '图片生成成功！': 'Immagine generata con successo!',
    },
    News: {
        '新闻资讯': 'Notizie',
        '了解': 'Scopri le',
        '的最新动态和产品更新': 'ultime novità e aggiornamenti dei prodotti',
        '精选': 'In evidenza',
        '阅读': 'Leggi',
        '点赞': 'Mi piace',
        '热门': 'Popolari',
        '最新': 'Recenti',
        '阅读更多': 'Leggi tutto',
        '加载中': 'Caricamento...',
        '暂无新闻': 'Nessuna notizia',
        '清除筛选': 'Cancella filtro',
        '加载新闻失败': 'Caricamento notizie fallito, riprova più tardi',
    },
    Price: {
        '选择适合您的方案': 'Scegli il piano adatto a te',
        '灵活的定价': 'Prezzi flessibili per diverse esigenze',
        '包月': 'Mensile',
        '包年': 'Annuale',
        '购买积分': 'Acquista crediti',
        '只需要几个视频': 'Hai bisogno solo di pochi video? Nessun abbonamento, acquista direttamente un pacchetto di crediti',
        '产品大全': 'Catalogo prodotti',
        '了解': 'Scopri',
        '全系列产品的详细信息和支付方式': 'informazioni dettagliate e metodi di pagamento per l\'intera gamma di prodotti'
    },
    Billing: {
        '账单管理': 'Gestione fatture',
        '账户余额': 'Saldo account',
        '本月支出': 'Spese mese corrente',
        '订单数量': 'Numero ordini',
        '账单列表': 'Elenco fatture',
        '请选择类型': 'Seleziona tipo',
        '请选择时间范围': 'Seleziona intervallo di tempo',
        '订单号': 'Numero ordine',
        '类型': 'Tipo',
        '金额': 'Importo',
        '状态': 'Stato',
        '时间': 'Data',
        '操作': 'Azione',
        '查看详情': 'Vedi dettagli',
        '下载发票': 'Scarica fattura',
        '暂无作品': 'Nessuna opera',
        '去创作': 'Crea',
        '支付方式': 'Metodo di pagamento',
        '添加支付方式': 'Aggiungi metodo',
        '默认': 'Predefinito',
        '设为默认': 'Imposta come predefinito',
        '编辑': 'Modifica',
        '删除': 'Elimina',
        '账单详情': 'Dettagli fattura',
        '交易流水号': 'Numero di transazione',
        '关闭': 'Chiudi',
        '账号': 'Account/Numero carta',
        '请输入账号或卡号': 'Inserisci il numero di account o carta',
        '姓名': 'Nome',
        '请输入持卡人姓名': 'Inserisci il nome del titolare della carta',
        '有效期': 'Data di scadenza',
        '请输入CVV码': 'Inserisci il codice CVV',
        '取消': 'Annulla',
        '确认添加': 'Conferma aggiunta',
        '确认修改': 'Conferma modifica',
        '确认删除': 'Conferma eliminazione',
        '编辑支付方式': 'Modifica metodo di pagamento',
        '确定要删除支付方式': 'Vuoi eliminare questo metodo di pagamento',
        '删除后不可恢复': 'L\'eliminazione è irreversibile, presta attenzione!',
        '请输入账号': 'Inserisci il numero di account/carta',
        '添加成功': 'Aggiunto con successo',
        '修改成功': 'Modificato con successo',
        '已设为默认支付方式': 'Impostato come metodo di pagamento predefinito',
        '删除成功': 'Eliminato con successo',
    },
    Credit: {
        '额度管理': 'Gestione crediti',
        '当前可用额度': 'Credito attualmente disponibile',
        '升级会员': 'Upgrade membership',
        '本月已用': 'Usato questo mese',
        '视频生成': 'Genera video',
        'AI图片': 'Immagine AI',
        '其他': 'Altro',
        '购买额度包': 'Acquista pacchetto crediti',
        '最受欢迎': 'Più popolare',
        '额度': 'Credito',
        '立即购买': 'Acquista ora',
        '使用记录': 'Cronologia utilizzo',
        '操作': 'Azione',
        '类型': 'Tipo',
        '额度变动': 'Variazione credito',
        '时间': 'Data',
        '购买': 'Acquista',
        '确认购买': 'Conferma acquisto',
        '金额': 'Importo: ',
        '获得': 'Ottenere',
        '取消': 'Annulla',
        '今天': 'Oggi',
        '昨天': 'Ieri',
    },
    Dashboard: {
        '欢迎回来': 'Bentornato,',
        '创建新视频': 'Crea nuovo video',
        '本月生成次数': 'Generazioni questo mese',
        '剩余额度': 'Credito residuo',
        '总视频数': 'Totale video',
        '会员状态': 'Stato membership',
        '最近生成': 'Generazioni recenti',
        '查看全部': 'Vedi tutti',
        '视频预览': 'Anteprima video',
        '视频生成中': 'Generazione video in corso, attendi per l\'anteprima',
    },
    Membership: {
        '会员中心': 'Area membri',
        '当前方案': 'Piano attuale',
        'Pro 会员': 'Pro',
        '专业创作者首选': 'La scelta migliore per i creatori professionisti',
        '月': 'mese',
        '会员有效期': 'Validità membership',
        '剩余天数': 'Giorni rimanenti',
        '续费会员': 'Rinnova',
        '取消订阅': 'Annulla abbonamento',
        '本月使用情况': 'Utilizzo mese corrente',
        '视频生成': 'Genera video',
        '次': 'volte',
        '额度使用': 'Utilizzo crediti',
        '快速生成': 'Generazione rapida',
        '升级方案': 'Upgrade piano',
        '联系销售': 'Contatta vendite',
        '会员权益': 'Vantaggi membri',
        '续费后将延长会员有效期30天': 'Il rinnovo prolunga la membership di 30 giorni',
        '取消': 'Annulla',
        '确认续费': 'Conferma rinnovo',
        '取消后您将失去所有会员权益': 'Dopo l\'annullamento perderai tutti i vantaggi, il credito residuo rimarrà',
        '再想想': 'Ripensaci',
        '确认取消': 'Conferma annullamento',
        '姓名': 'Nome',
        '请输入您的姓名': 'Inserisci il tuo nome',
        '请输入姓名': 'Inserisci il nome',
        '公司': 'Azienda',
        '请输入公司名称': 'Inserisci il nome dell\'azienda',
        '邮箱': 'Email',
        '请输入邮箱地址': 'Inserisci l\'indirizzo email',
        '请输入邮箱': 'Inserisci l\'email',
        '请输入正确的邮箱格式': 'Inserisci un formato email valido',
        '需求': 'Richiesta',
        '请描述您的需求': 'Descrivi la tua richiesta',
        '提交': 'Invia',
        '请填写需求': 'Descrivi la richiesta',
        '续费成功': 'Rinnovo riuscito! La membership è stata estesa',
        '已取消订阅': 'Abbonamento annullato, la membership scadrà alla fine del periodo',
        '提交成功': 'Invio riuscito, ti contatteremo presto!',
    },
    Task: {
        '生成任务': 'Attività di generazione',
        '新建任务': 'Nuova attività',
        '进行中': 'In corso',
        '已完成': 'Completata',
        '失败': 'Fallita',
        '队列中': 'In coda',
        '活跃任务': 'Attività attive',
        '刷新': 'Aggiorna',
        '暂无活跃任务': 'Nessuna attività attiva',
        '预计剩余': 'Tempo residuo stimato',
        '暂停': 'Pausa',
        '继续': 'Continua',
        '取消': 'Annulla',
        '最近完成': 'Completate di recente',
        '查看全部': 'Vedi tutti',
        '暂无完成的任务': 'Nessuna attività completata',
        '播放': 'Riproduci',
        '下载': 'Scarica',
        '分享': 'Condividi',
        '确认取消': 'Conferma annullamento',
        '确定要取消任务吗': 'Vuoi davvero annullare l\'attività?',
        '已消耗的额度将无法退还': 'Il credito consumato non sarà rimborsabile',
        '返回': 'Indietro',
        '分享作品': 'Condividi opera',
        '复制链接': 'Copia link',
        '任务列表已刷新': 'Elenco attività aggiornato',
        '已暂停': 'In pausa',
        '生成中': 'Generazione in corso',
        '已恢复': 'Ripresa',
        '任务已取消': 'Attività annullata',
        '链接已复制到剪贴板': 'Link copiato negli appunti',
    },
    VideoShow: {
        '示例': 'Esempi',
        '来自我们演示库的一套精心挑选的剪辑片段，点击任何卡片即可开始生成与之风格相似的素材。': 'Una selezione curata di clip dalla nostra libreria demo. Clicca su qualsiasi carta per iniziare a generare contenuti con stile simile.',
        '全部': 'Tutti',
        '电影感': 'Cinematografico',
        '角色': 'Personaggi',
        '产品': 'Prodotti',
        '自然': 'Natura',
        '趣味': 'Divertente',
        '加载中': 'Caricamento',
        '暂无展示': 'Nessuna demo disponibile',
        '视频预览': 'Anteprima video',
    },
    Request: {
        '加载中': 'Caricamento in corso...',
        '您已退出登录': 'Hai effettuato il logout, puoi accedere di nuovo',
        '确认退出': 'Conferma logout',
        '重新登录': 'Accedi di nuovo',
        '错误': 'Errore',
        '网络错误': 'Errore di rete',
        '下载中': 'Download in corso...'
    },
    Other: {
        '剩余额度': 'Credito residuo',
        '去登录': 'Accedi',
        '请登录后查看': 'Effettua il login per visualizzare',
        '任务': 'Attività',
        '可在「生成任务」中查看详情': ', i dettagli sono disponibili in "Attività di generazione"',
        '查看详情': 'Visualizza dettagli',
        '排队中': 'In coda',
        '运行中': 'In esecuzione',
        '取消': 'Annulla',
        '成功': 'Successo',
        '失败': 'Fallito',
        '超时': 'Timeout',
        '最后更新': 'Ultimo aggiornamento:',
        '视频生成': 'Generazione video',
        '活跃用户': 'Utenti attivi',
        '用户评分': 'Valutazione utenti',
        '万': 'mila',
        '快速生成': 'Generazione rapida',
        '先进的AI模型': 'Modelli AI avanzati che generano video di alta qualità in pochi minuti',
        '多种风格': 'Stili multipli',
        '多种风格任您选择': 'Realistico, anime, artistico e molti altri stili tra cui scegliere',
        '高清输出': 'Output HD',
        '支持4K超高清视频输出': 'Supporta output video 4K Ultra HD, dettagli nitidi e chiari',
        '商用授权': 'Licenza commerciale',
        '生成的视频可用于商业用途': 'I video generati possono essere utilizzati per scopi commerciali, senza preoccupazioni di copyright',
        '原价': 'Prezzo originale',
        '积分价格说明': 'Spiegazione prezzi crediti',
        '系列': 'Serie',
        '模型': 'Modello',
        '分辨率': 'Risoluzione',
        '积分': 'Crediti',
        '秒': 'secondo',
        '秒示例': 'secondi (esempio)',
        '图片模型': 'Modello immagine',
        '图片为': 'L\'immagine è',
        '系列产品': 'Prodotti della serie, attualmente supporta',
        '支持使用任意机型查看完整体验': ', supporta l\'uso di qualsiasi dispositivo per un\'esperienza completa.',
        '计费方式': 'Metodo di fatturazione',
        '张': 'immagine(i)',
        '按生成张数计费': 'Fatturazione in base al numero di immagini generate',
        '普通用户': 'Utente normale',
        '无记录': 'Nessun record',
        '总支出': 'Spesa totale',
        '月总使用': 'Utilizzo totale mensile',
        '月视频使用': 'Utilizzo video mensile',
        '月图片使用': 'Utilizzo immagini mensile',
        '生成成功': 'Generazione riuscita',
        '视频总生成': 'Totale video generati',
        '图片总生成': 'Totale immagini generate',
        '生成中': 'Generazione in corso, attendere 1-3 minuti',
        '来自我们演示库的一套精心挑选的剪辑片段': 'Una collezione di clip selezionate con cura dalla nostra libreria demo.',
        '最近7天': 'Ultimi 7 giorni',
        '最近30天': 'Ultimi 30 giorni',
        '本月': 'Questo mese',
        '上月': 'Mese scorso',
        '选择支付方式': 'Seleziona metodo di pagamento',
        '确认支付': 'Conferma pagamento'
    }
}